import React, { useState } from "react";

// Models
import { SuppliersToEvaluateResponse } from "@/main/models/response";

// Styles
import * as S from "./styles";

// Components
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import Button from "@/main/components/shared/button/button";

// Utils
import { getTranslateByKey } from "@/main/services/utils";
import { evaluationCompanyBuyerApi } from "@/main/api";

interface IModalEvaluationSupplierAlertProps {
	isOpenModal: boolean;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
	onConfirm: () => void;
	suppliers: SuppliersToEvaluateResponse[];
	guidProcurement: string;
}
function ModalEvaluationSupplierAlert({
	suppliers,
	closeModal,
	onConfirm,
	guidProcurement,
}: IModalEvaluationSupplierAlertProps) {
	// Constants
	const PREFIX_ID_ELEMENTS_MODAL = "id-modalEvaluationSupplierAlert-";
	// States
	const [isSaving, setIsSaving] = useState<boolean>(false);

	return (
		<S.ContainerModal>
			<h6>{getTranslateByKey("information.evaluateYourSuppliers")}</h6>
			<S.ContainerAlertMessage>
				{getTranslateByKey("information.evaluationsAvailable").replace("{0}", String(suppliers.length))}
			</S.ContainerAlertMessage>
			<S.AreaButtons>
				<SecondaryButton
					id={`${PREFIX_ID_ELEMENTS_MODAL}btn-evaluate-later`}
					type="button"
					isLoading={isSaving}
					onClick={() => {
						setIsSaving(true);
						evaluationCompanyBuyerApi
							.saveSupplierEvaluation({
								ignoreSupplierEvaluation: true,
								guidProcurement,
							})
							.then(() => {
								closeModal();
							})
							.finally(() => setIsSaving(false));
					}}
				>
					{getTranslateByKey("information.evaluateLater")}
				</SecondaryButton>
				<Button
					type="button"
					onClick={() => onConfirm()}
					style={{ marginLeft: "unset" }}
					id={`${PREFIX_ID_ELEMENTS_MODAL}btn-yes`}
				>
					{getTranslateByKey("information.yes")}
				</Button>
			</S.AreaButtons>
		</S.ContainerModal>
	);
}

function WrapperModalEvaluationSupplierAlert(props: IModalEvaluationSupplierAlertProps) {
	return (
		<KogModalFadeComponent open={props.isOpenModal} setOpen={props.setIsOpenModal}>
			<ModalEvaluationSupplierAlert {...props} />
		</KogModalFadeComponent>
	);
}

export default WrapperModalEvaluationSupplierAlert;
